import { render } from "./StatisticalTimeTable.vue?vue&type=template&id=bb0fac1c"
import script from "./StatisticalTimeTable.vue?vue&type=script&lang=js"
export * from "./StatisticalTimeTable.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src4026252432/src/luca_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__